import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import {
  SelfProductionPlantsReadDTO,
  SelfProductionPlantsCreateDTO,
  DiagnosisSelfProductionPlantsReadDTO,
  DiagnosisSelfProductionPlantsCreateDTO,
} from '../generated/api-client';

export const useSelfProductionPlants = () => {
  return useQuery<SelfProductionPlantsReadDTO[]>('selfProductionPlants', () => apiClient.list_items_self_production_plants__get());
};

export const useSelfProductionPlantsById = (id: string) => {
  return useQuery<SelfProductionPlantsReadDTO>(
    ['selfProductionPlants', id],
    () => apiClient.get_item_self_production_plants__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useSelfProductionPlantsByDiagnosisId = (diagnosisId: string) => {
  return useQuery<DiagnosisSelfProductionPlantsReadDTO[]>(
    ['diagnosisSelfProductionPlants', diagnosisId],
    () =>
      apiClient.search_by_diagnosis_id_diagnosis_self_production_plants_search_by_diagnosis_id__diagnosis_id__get(
        diagnosisId
      ),
    {
      enabled: !!diagnosisId,
    }
  );
};

export const useCreateSelfProductionPlants = () => {
  const queryClient = useQueryClient();

  return useMutation<SelfProductionPlantsReadDTO, Error, SelfProductionPlantsCreateDTO>(
    (data) => apiClient.create_item_self_production_plants__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('selfProductionPlants');
      },
    }
  );
};

export const useUpdateSelfProductionPlants = () => {
  const queryClient = useQueryClient();

  return useMutation<SelfProductionPlantsReadDTO, Error, { id: string; data: SelfProductionPlantsCreateDTO }>(
    ({ id, data }) => apiClient.update_item_self_production_plants__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('selfProductionPlants');
      },
    }
  );
};

export const useDeleteSelfProductionPlants = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_self_production_plants__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('selfProductionPlants');
      },
    }
  );
};

